import React from 'react';
import { Stack, Separator, getTheme } from '@fluentui/react';
import { TooltipText } from '../../shared';
import { TimeField } from '../rules';
import { ConfigPrecentageField, PercentageConfig } from './ConfigPrecentageField';
import { AdminContext } from 'Store/Admin';
import { ValidationMessage } from './ValidationMessage';
import { FieldSectionComponent } from '../FieldSectionComponent';
import { separatorStyle } from '../SettingsStyles';
import { TimeConfig } from './TimeField';

export const SLA: React.FunctionComponent = () => {
  const { palette, fonts } = getTheme();

  const { state } = React.useContext(AdminContext);

  // TODO: Pull queueDataState to a higher level and make it a required prop in this component
  if (!state.queueDataState) {
    return <>{'loading...'}</>;
  }

  return (
    <div className="ms-grid-row mb-4">
      <FieldSectionComponent title={TooltipText.subtitleCaseOpenSLA} body={TooltipText.configCaseOpenLifetimeInSeconds}>
        <Stack.Item>
          <TimeField
            className="ms-Grid-col ms-sm12 ms-md12"
            tooltip={''}
            config={TimeConfig.CaseOpenLifetimeInSeconds}
            label={{ hours: 'Hours', minutes: 'Minutes' }}
            value={state.queueDataState.caseOpenLifetimeInSeconds}
          />
        </Stack.Item>
        <Stack.Item className="pl-2">
          {state.queueDataState.caseOpenLifetimeInSeconds === 0 && (
            <ValidationMessage message={TooltipText.validationTimeMessage} fonts={fonts} />
          )}
        </Stack.Item>
      </FieldSectionComponent>

      <Separator styles={separatorStyle(palette)} />

      <FieldSectionComponent
        title={TooltipText.subtitleNearSLAWarningFactor}
        body={TooltipText.configCaseOpenLifetimeWarningFactor}
      >
        <Stack.Item className="position-relative">
          <ConfigPrecentageField
            tooltip={''}
            config={PercentageConfig.CaseOpenLifetimeWarningFactor}
            label="Percentage"
          />
        </Stack.Item>
      </FieldSectionComponent>

      <Separator styles={separatorStyle(palette)} />

      <FieldSectionComponent
        title={TooltipText.subtitleTimeLimitForCaseSets}
        body={TooltipText.configCaseAssignedLifetimeInSeconds}
      >
        <Stack.Item>
          <TimeField
            className="ms-Grid-col ms-sm12 ms-md12"
            tooltip={''}
            config={TimeConfig.CaseAssignedLifetimeInSeconds}
            label={{ hours: 'Hours', minutes: 'Minutes' }}
            value={state.queueDataState.caseAssignedLifetimeInSeconds}
          />
        </Stack.Item>
        <Stack.Item className="pl-2">
          {state.queueDataState.caseAssignedLifetimeInSeconds === 0 && (
            <ValidationMessage message={TooltipText.validationTimeMessage} fonts={fonts} />
          )}
        </Stack.Item>
      </FieldSectionComponent>

      <Separator styles={separatorStyle(palette)} />

      <FieldSectionComponent
        title={TooltipText.subtitleCaseCollapsingWindow}
        body={TooltipText.configCollapsingWindowInSeconds}
      >
        <Stack.Item>
          <TimeField
            className="ms-Grid-col ms-sm12 ms-md12"
            tooltip={''}
            config={TimeConfig.CaseOpenLifetimeMaxInSeconds}
            label={{ days: 'Days', hours: 'Hours', minutes: 'Minutes' }}
            value={state.queueDataState.caseOpenLifetimeMaxInSeconds}
          />
        </Stack.Item>
        <Stack.Item className="pl-2">
          {state.queueDataState.caseOpenLifetimeMaxInSeconds === 0 && (
            <ValidationMessage message={TooltipText.validationTimeMessage} fonts={fonts} />
          )}
        </Stack.Item>
      </FieldSectionComponent>
    </div>
  );
};
